class Countdown {
  constructor() {
    this.timer = null;
    this.timeLeft = 60;
    this.status = 'stopped';
  }

  updateTimeLeft(value) {
    this.timeLeft = value;
    if (this.callback) {
      this.callback(this.timeLeft);
    }
  }

  decrement() {
    this.updateTimeLeft(this.timeLeft - 1);
    if (this.timeLeft <= 0) {
      this.stop();
    }
  }

  start() {
    if (this.timer) this.stop();
    this.updateTimeLeft(60);
    this.timer = setInterval(() => this.decrement(), 1000);
    this.status = 'started';
  }

  stop() {
    clearInterval(this.timer);
    this.status = 'stopped';
  }

  bind(callback) {
    this.callback = callback;
    this.callback(this.timeLeft);
  }
}

export default Countdown;
